module.exports = __webpack_public_path__ + "static/img/1.d451a0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/1.png
// module id = hjcN
// module chunks = 0